// French for the LATEST zone: the newest entries of the merged stream.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Latest': 'Derniers',
  '{n} new in the last 14 days': '{n} nouveauté(s) au cours des 14 derniers jours',
  '{n} new since {date}': '{n} nouveauté(s) depuis {date}',
  'nothing new in the last 14 days': 'aucune nouveauté au cours des 14 derniers jours',
  'nothing new since {date}': 'aucune nouveauté depuis {date}',
  'newest {shown} of {total}': 'les {shown} plus récents sur {total}',
  'Library': 'Bibliothèque',
  'Full timeline': 'Chronologie complète',
  'Nothing on the record yet — no document ingested, no timeline event written.': 'Rien au dossier pour l’instant — aucun document ingéré, aucun événement inscrit sur la chronologie.',
  'superseded by': 'remplacé par',
  'No summary on record.': 'Aucun résumé disponible.',
  'show the newest six': 'afficher les six plus récents',
  '{n} older on this strip': '{n} plus anciens sur ce bandeau',
  // entry.kind ?? entry.layer — the event kinds and the two layers
  'document': 'document',
  'event': 'événement',
  'meeting': 'réunion',
  'decision': 'décision',
  'signature': 'signature',
  'commitment': 'promesse',
  'milestone': 'jalon',
  'participant': 'participant',
  'note': 'note',
}, 'ClientLatest');
